import {
  Box,
  Flex,
  Heading,
  HStack,
  Image,
  Link,
  Icon,
  // Spacer,
  VStack,
  // Tooltip,
  // Button,
  // Divider,
  Text,
  // useBreakpointValue,
} from "@chakra-ui/react";
// import { MdMenu } from "react-icons/md";
// import { CloseIcon } from "@chakra-ui/icons";
import Enso from "../../../assets/images/Enso.png";
import Universal from "../../../assets/images/universal.png";
// import { motion } from "framer-motion";
import {
  // FaFacebook,
  FaInstagram,
  FaEnvelope,
  // FaLinkedin,
  FaPhoneAlt,
  FaWhatsapp,
  FaMapMarkerAlt,
  // FaPinterest,
  // FaInfoCircle,
  FaHome,
  // FaTwitter,
  // FaFacebookF,
  FaProjectDiagram,
  // FaYoutube,
  // FaPaperPlane,
  // FaDownload,
} from "react-icons/fa";
import { HiOutlineUserGroup } from "react-icons/hi";
import { BiCloudDownload } from "react-icons/bi";

const Footer = (props) => {
  return (
    <Box
      bg="#000000"
      color="white"
      borderTop="1px solid"
      borderColor="#000000"
    >
      <Box pt={{ base: 6, md: 20 }} pb={6} pl={{ base: 6, md: 32}} pr={{ base: 6, md: 32}}>
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align={{ base: "start", md: "start" }}
          wrap="wrap"
          gap={8}
        >
          <VStack
            align="start"
            spacing={4}
            maxW="300px"
            pr={4}
            pb={4}
            // bg="white"
            borderRadius="lg"
            boxShadow="sm"
          >
            <Flex align="flex-end">
              <Image
                src={Enso}
                alt="Enso"
                maxWidth="60px"
                objectFit="cover"
                mb={6}
                opacity={0.9}
              />
              <Image
                src={Universal}
                alt="Universal"
                maxWidth="110px"
                objectFit="cover"
                opacity={0.9}
              />
              {/* <Text
                fontSize="2xl"
                lineHeight="tall"
                fontWeight="semibold"
                fontFamily="system-ui, sans-serif"
              >
                Universal
              </Text> */}
            </Flex>
            <Text
              fontSize="md"
              lineHeight="tall"
              fontWeight="light"
              fontStyle="italic"
            >
              "Your Space, Our Crafted Perfection. Creating timeless designs
              with innovative solutions."
            </Text>
          </VStack>
          <VStack align="start" spacing={4}>
            <Heading
              as="h3"
              size="md"
              fontWeight="semibold"
              pb={2}
              // borderBottom="2px solid"
              // borderColor="#002366"
            >
              MENU
            </Heading>
            {[
              { text: "Home", path: "/", icon: FaHome },
              { text: "About Us", path: "/about", icon: HiOutlineUserGroup },
              { text: "Projects", path: "/project", icon: FaProjectDiagram },
              { text: "Downloads", path: "/download", icon: BiCloudDownload },
            ].map((item) => (
              <Box key={item.text}>
                <Link
                  href={item.path}
                  display="flex"
                  alignItems="center"
                  gap={2}
                  _hover={{
                    color: "whiteAlpha.800",
                    transform: "translateX(4px)",
                    transition: "all 0.2s ease",
                  }}
                >
                  <Icon as={item.icon} boxSize={5} color="#ffffff" />
                  {item.text}
                </Link>
              </Box>
            ))}
          </VStack>

          <VStack align="start" spacing={4}>
            <Heading
              as="h3"
              size="md"
              fontWeight="semibold"
              pb={2}
              // borderBottom="2px solid"
              // borderColor="#002366"
            >
              CONTACT
            </Heading>
            <HStack spacing={3} align="start">
              <Icon as={FaEnvelope} color="#ffffff" boxSize={5} mt={0.5} />
              <VStack align="start" spacing={0}>
                {/* <Text fontSize="md" fontWeight="medium">
                  Email
                </Text> */}
                <Link
                  href="mailto:sales@enso.com"
                  isExternal
                  _hover={{ textDecoration: "none" }}
                >
                  <Text fontSize="sm" opacity={0.8}>
                    sales@enso.com
                  </Text>
                </Link>
              </VStack>
            </HStack>
            <HStack spacing={3} align="start">
              <Icon as={FaPhoneAlt} color="#ffffff" boxSize={5} mt={0.5} />
              <VStack align="start" spacing={0}>
                {/* <Text fontSize="md" fontWeight="medium">
                  Phone
                </Text> */}
                <Link
                  href="tel:+916357117778"
                  isExternal
                  _hover={{ textDecoration: "none" }}
                >
                  <Text fontSize="sm"  opacity={0.8}>
                    +91 6357117778 / 80
                  </Text>
                </Link>
              </VStack>
            </HStack>
            <HStack spacing={3} align="start">
              <Icon as={FaMapMarkerAlt} color="#ffffff" boxSize={5} mt={0.5} />
              <VStack align="start" spacing={0}>
                {/* <Text fontSize="md" fontWeight="medium">
                  Address
                </Text> */}
                <Text fontSize="sm" opacity={0.8}>
                  ENSO Universal Pvt Ltd,
                </Text>
                <Text fontSize="sm" opacity={0.8}>
                  Akhabar Nagar, Ahmedabad, India
                </Text>
              </VStack>
            </HStack>
          </VStack>

          <VStack align="start" spacing={4}>
            <Heading
              as="h3"
              size="md"
              fontWeight="semibold"
              pb={2}
              // borderBottom="2px solid"
              // borderColor="#002366"
            >
              FOLLOW US
            </Heading>
            <Text fontSize="sm" opacity={0.8}>
              Connect with us on social media
            </Text>
            <HStack spacing={3}>
              {/* Facebook */}
              {/* <Link
                href="https://facebook.com/"
                aria-label="Facebook"
                isExternal
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="38px"
                h="38px"
                borderRadius="full"
                bg="white"
                _hover={{
                  transform: "translateY(-2px)",
                  transition: "all 0.2s ease",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 48 48"
                  width="24px"
                  height="24px"
                >
                  <path
                    fill="#0866FF"
                    d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"
                  />
                  <path
                    fill="#fff"
                    d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"
                  />
                </svg>
              </Link> */}

              {/* Twitter/X */}
              {/* <Link
                href="https://x.com/"
                aria-label="X (formerly Twitter)"
                isExternal
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="38px"
                h="38px"
                borderRadius="full"
                bg="black"
                _hover={{
                  bg: "blackAlpha.800",
                  transform: "translateY(-2px)",
                  transition: "all 0.2s ease",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                    fill="white"
                  />
                </svg>
              </Link> */}

              {/* Instagram */}
              <Link
                href="https://www.instagram.com/enso_luxurious_living/?hl=en"
                aria-label="Instagram"
                isExternal
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="38px"
                h="38px"
                borderRadius="full"
                bgGradient="linear(to-tr, #f9ce34, #ee2a7b, #6228d7)"
                _hover={{
                  transform: "translateY(-2px)",
                  transition: "all 0.2s ease",
                }}
              >
                <Icon as={FaInstagram} color="white" boxSize="20px" />
              </Link>

              {/* LinkedIn */}
              {/* <Link
                href="https://www.linkedin.com/"
                aria-label="LinkedIn"
                isExternal
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="38px"
                h="38px"
                borderRadius="full"
                border="1px solid"
                borderColor="#0A66C2"
                bg="#0A66C2"
                _hover={{
                  transform: "translateY(-2px)",
                  transition: "all 0.2s ease",
                }}
              >
                <Icon as={FaLinkedin} color="white" boxSize="20px" />
              </Link> */}

              {/* YouTube */}
              {/* <Link
                href="https://www.youtube.com/"
                aria-label="YouTube"
                isExternal
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="38px"
                h="38px"
                borderRadius="full"
                bg="white"
                _hover={{
                  transform: "translateY(-2px)",
                  transition: "all 0.2s ease",
                }}
              >
                <svg viewBox="0 0 24 24" width="24px" height="24px">
                  <rect
                    x="2"
                    y="4"
                    width="20"
                    height="16"
                    rx="4"
                    fill="#ff0000"
                  />
                  <path
                    d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                    fill="#ffffff"
                  />
                </svg>
              </Link> */}

              {/* WhatsApp */}
              <Link
                href="https://wa.me/916357117778"
                aria-label="WhatsApp"
                isExternal
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="38px"
                h="38px"
                borderRadius="full"
                bg="#25D366"
                _hover={{
                  transform: "translateY(-2px)",
                  transition: "all 0.2s ease",
                }}
              >
                <Icon as={FaWhatsapp} color="white" boxSize="20px" />
              </Link>
            </HStack>
            {/* <Box pt={4}>
          <Text fontWeight="medium" mb={2}>Subscribe to our newsletter</Text>
          <InputGroup>
            <Input 
              placeholder="Your email" 
              _placeholder={{ opacity: 0.6 }}
              borderColor="#000000"
              focusBorderColor="blue"
            />
            <InputRightElement>
              <IconButton
                aria-label="Subscribe"
                icon={<FaPaperPlane />}
                colorScheme="blue"
                size="sm"
                variant="ghost"
              />
            </InputRightElement>
          </InputGroup>
        </Box> */}
          </VStack>
        </Flex>

        <Flex
          borderTop="1px solid"
          borderColor="#000000"
          mt={12}
          pt={8}
          justify="center"
          align="center"
          direction={{ base: "column", md: "row" }}
          gap={4}
        >
          {/* <HStack spacing={6}>
        <Link fontSize="sm" _hover={{ color: "blue" }}>Terms & Conditions</Link>
        <Link fontSize="sm" _hover={{ color: "blue" }}>Privacy Policy</Link>
        <Link fontSize="sm" _hover={{ color: "blue" }}>Cookie Policy</Link>
      </HStack> */}
          <Text fontSize="sm" opacity={0.7}>
            Copyright © {new Date().getFullYear()} ENSO. All Rights Reserved.
          </Text>
        </Flex>
      </Box>
    </Box>
  );
};

export default Footer;
